export function cleanPhoneNumber(phoneValue) {
    return (phoneValue === null || phoneValue === void 0 ? void 0 : phoneValue.replace(/[+\s()-.]/g, "")) || "";
}
